declare namespace $ {

	type $mol_view__sub_shm_projects_goal_1 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['goal_form'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_projects_goal_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_projects_goal_3 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['ask_questions'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_link__arg_shm_projects_goal_4 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_result_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_goal_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_goal_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__click_shm_projects_goal_7 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_select'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_text__text_shm_projects_goal_8 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_status_state'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_projects_goal_9 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_projects_goal['prerelease_status_color'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_text__text_shm_projects_goal_10 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_status_elapsed'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_projects_goal_11 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_goal_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_check_box__title_shm_projects_goal_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_projects_goal_13 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['ask_questions'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $shm_projects_goal_chat__run_shm_projects_goal_14 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['run_data'] >
		,
		ReturnType< $shm_projects_goal_chat['run'] >
	>
	type $shm_projects_goal_chat__iteration_shm_projects_goal_15 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['selected_iteration_number'] >
		,
		ReturnType< $shm_projects_goal_chat['iteration'] >
	>
	type $shm_projects_goal_chat__prerelease_shm_projects_goal_16 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_selected'] >
		,
		ReturnType< $shm_projects_goal_chat['prerelease'] >
	>
	type $shm_projects_goal_chat__version_shm_projects_goal_17 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['version'] >
		,
		ReturnType< $shm_projects_goal_chat['version'] >
	>
	type $shm_projects_goal_chat__workspace_id_shm_projects_goal_18 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['result_workspace_id'] >
		,
		ReturnType< $shm_projects_goal_chat['workspace_id'] >
	>
	type $shm_projects_goal_chat__clarifications_shm_projects_goal_19 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['goal_process_clarifications'] >
		,
		ReturnType< $shm_projects_goal_chat['clarifications'] >
	>
	type $shm_projects_goal_chat__after_shm_projects_goal_20 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['goal_result_after'] >
		,
		ReturnType< $shm_projects_goal_chat['after'] >
	>
	type $mol_view__sub_shm_projects_goal_21 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['goal_result'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_shm_projects_goal_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_projects_goal_23 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['send_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_projects_goal_24 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['send'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $shm_projects_goal_request__label_shm_projects_goal_25 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['requirements_label'] >
		,
		ReturnType< $shm_projects_goal_request['label'] >
	>
	type $shm_projects_goal_request__requirements_shm_projects_goal_26 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_projects_goal_request['requirements'] >
	>
	type $shm_projects_goal_request__value_shm_projects_goal_27 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['requirements'] >
		,
		ReturnType< $shm_projects_goal_request['value'] >
	>
	type $shm_projects_goal_request__attachments_shm_projects_goal_28 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['requirements_attachments'] >
		,
		ReturnType< $shm_projects_goal_request['attachments'] >
	>
	type $shm_projects_goal_request__after_shm_projects_goal_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_projects_goal_request['after'] >
	>
	type $mol_list__rows_shm_projects_goal_30 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['timeline_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_goal_31 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['clarifications_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_goal_33 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['clarification_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_shm_projects_goal_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_projects_goal_35 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['clarifications_send_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_projects_goal_36 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['clarifications_send'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_form_field__name_shm_projects_goal_37 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['clarification_question'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_goal_38 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['clarification_answer_content'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_goal_39 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['clarification_answer'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_text__text_shm_projects_goal_40 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['clarification_answer'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_goal_41 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_status_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_43 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_status_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_44 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_status_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_shm_projects_goal_46 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['result_iteration_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_goal_47 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_status_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_goal_48 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__click_shm_projects_goal_49 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_select'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_text__text_shm_projects_goal_50 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_status_state'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_projects_goal_51 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_projects_goal['iteration_status_color'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_text__text_shm_projects_goal_52 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_status_elapsed'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__attr_shm_projects_goal_53 = $mol_type_enforce<
		({ 
			'title': ReturnType< $shm_projects_goal['iteration_status_elapsed_details'] >,
		})  & ReturnType< $mol_text['attr'] >
		,
		ReturnType< $mol_text['attr'] >
	>
	type $mol_button_minor__title_shm_projects_goal_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_goal_55 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_rollback'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_form_field__rows_shm_projects_goal_56 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_goal_rows'] >
		,
		ReturnType< $mol_form_field['rows'] >
	>
	type $mol_form_field__name_shm_projects_goal_57 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_goal_label'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_goal_58 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['Iteration_goal_text'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_button_minor__title_shm_projects_goal_59 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_goal_60 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['stop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_shm_projects_goal_61 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_projects_goal_62 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['continue'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_projects_goal_63 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_goal_64 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['rollback_all'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_list__rows_shm_projects_goal_65 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_goal_66 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_67 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_goal_68 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_event_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_text__text_shm_projects_goal_69 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_event_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_projects_goal_70 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_summary'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_goal_71 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['iteration_change_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_72 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_goal_74 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_state'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_projects_goal_75 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_projects_goal['prerelease_status_color'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_text__text_shm_projects_goal_76 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_external_note'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_shm_projects_goal_77 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_event_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_text__text_shm_projects_goal_78 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_event_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_projects_goal_79 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_summary'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_goal_80 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_change_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_81 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_change_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_82 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_goal_83 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_change_description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_goal_84 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_change_screenshot_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_85 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_change_demo_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_goal_demo__uri_shm_projects_goal_86 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_change_demo_uri'] >
		,
		ReturnType< $shm_projects_goal_demo['uri'] >
	>
	type $shm_projects_image_viewer__uri_shm_projects_goal_87 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_change_screenshot_uri'] >
		,
		ReturnType< $shm_projects_image_viewer['uri'] >
	>
	type $mol_button_minor__title_shm_projects_goal_88 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_goal_89 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['stop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_shm_projects_goal_90 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_continue_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_projects_goal_91 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_continue'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_projects_goal_92 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_goal_93 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['prerelease_accept_external'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_projects_goal_94 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['result_change_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_95 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_goal_96 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['result_change_description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_goal_97 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['result_change_screenshot_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_98 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['result_change_demo_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_goal_demo__uri_shm_projects_goal_99 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['result_change_demo_uri'] >
		,
		ReturnType< $shm_projects_goal_demo['uri'] >
	>
	type $shm_projects_image_viewer__uri_shm_projects_goal_100 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['result_change_screenshot_uri'] >
		,
		ReturnType< $shm_projects_image_viewer['uri'] >
	>
	type $mol_button_major__title_shm_projects_goal_101 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_projects_goal_102 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['refine'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $shm_projects_goal_request__label_shm_projects_goal_103 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['refinement_label'] >
		,
		ReturnType< $shm_projects_goal_request['label'] >
	>
	type $shm_projects_goal_request__refinement_shm_projects_goal_104 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_projects_goal_request['refinement'] >
	>
	type $shm_projects_goal_request__value_shm_projects_goal_105 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['refinement'] >
		,
		ReturnType< $shm_projects_goal_request['value'] >
	>
	type $shm_projects_goal_request__attachments_shm_projects_goal_106 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['refinement_attachments'] >
		,
		ReturnType< $shm_projects_goal_request['attachments'] >
	>
	type $shm_projects_goal_request__after_shm_projects_goal_107 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_projects_goal_request['after'] >
	>
	type $mol_list__rows_shm_projects_goal_108 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['artifact_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_link__uri_shm_projects_goal_109 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['artifact_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_projects_goal_110 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__title_shm_projects_goal_111 = $mol_type_enforce<
		ReturnType< $shm_projects_goal['artifact_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_goal_112 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $shm_projects_goal extends $mol_view {
		goal_form( ): readonly(any)[]
		Form( ): $mol_view
		run_data( next?: any ): any
		selected_iteration_number( ): number
		prerelease_selected( ): boolean
		version( ): string
		result_workspace_id( ): string
		goal_process_clarifications( ): readonly(any)[]
		goal_result_after( ): readonly(any)[]
		goal_result( ): readonly(any)[]
		send_enabled( ): boolean
		send( next?: any ): any
		Requirements_field( ): ReturnType< ReturnType< $shm_projects_goal['Requirements_draft'] >['Field'] >
		requirements_label( ): string
		requirements( next?: string ): string
		requirements_attachments( next?: readonly(any)[] ): readonly(any)[]
		Ask_questions( ): $mol_check_box
		timeline_rows( ): readonly(any)[]
		clarifications_content( ): readonly(any)[]
		clarification_rows( ): readonly(any)[]
		clarifications_send_enabled( ): boolean
		clarifications_send( next?: any ): any
		clarification_question( id: any): string
		clarification_answer_content( id: any): any
		clarification_answer( id: any): string
		prerelease_status_content( ): readonly(any)[]
		prerelease_result_arg( ): Record<string, any>
		prerelease_select( next?: any ): any
		Prerelease_status_link( ): $mol_link
		prerelease_status_state( ): string
		prerelease_status_color( ): string
		Prerelease_status_state( ): $mol_text
		prerelease_status_elapsed( ): string
		Prerelease_status_elapsed( ): $mol_text
		iteration_status_content( id: any): readonly(any)[]
		iteration_status_rows( id: any): readonly(any)[]
		iteration_status_title( id: any): string
		result_iteration_arg( id: any): Record<string, any>
		iteration_select( id: any, next?: any ): any
		iteration_status_state( id: any): string
		iteration_status_color( id: any): string
		iteration_status_elapsed( id: any): string
		iteration_status_elapsed_details( id: any): string
		iteration_rollback( id: any, next?: any ): any
		iteration_goal_rows( id: any): readonly(any)[]
		iteration_goal_label( id: any): string
		iteration_goal_text( id: any): string
		Iteration_goal_text( id: any): $mol_text
		stop( next?: any ): any
		continue( next?: any ): any
		rollback_all( next?: any ): any
		iteration_rows( ): readonly(any)[]
		iteration_content( id: any): readonly(any)[]
		iteration_title( id: any): string
		iteration_event_rows( id: any): readonly(any)[]
		iteration_event_text( id: any): string
		iteration_summary( id: any): string
		iteration_change_rows( id: any): readonly(any)[]
		prerelease_content( ): readonly(any)[]
		prerelease_state( ): string
		prerelease_external_note( ): string
		prerelease_event_rows( ): readonly(any)[]
		prerelease_event_text( id: any): string
		prerelease_summary( ): string
		prerelease_change_rows( ): readonly(any)[]
		prerelease_change_content( id: any): readonly(any)[]
		prerelease_change_title( id: any): string
		prerelease_change_description( id: any): string
		prerelease_change_screenshot_rows( id: any): readonly(any)[]
		prerelease_change_demo_rows( id: any): readonly(any)[]
		prerelease_change_demo_uri( id: any): string
		prerelease_change_screenshot_uri( id: any): string
		prerelease_continue_title( ): string
		prerelease_continue( next?: any ): any
		prerelease_accept_external( next?: any ): any
		result_change_content( id: any): readonly(any)[]
		result_change_title( id: any): string
		result_change_description( id: any): string
		result_change_screenshot_rows( id: any): readonly(any)[]
		result_change_demo_rows( id: any): readonly(any)[]
		result_change_demo_uri( id: any): string
		result_change_screenshot_uri( id: any): string
		refine( next?: any ): any
		Refinement_field( ): ReturnType< ReturnType< $shm_projects_goal['Refinement_draft'] >['Field'] >
		refinement_label( ): string
		refinement( next?: string ): string
		refinement_attachments( next?: readonly(any)[] ): readonly(any)[]
		Refinement_ask_questions( ): $mol_check_box
		artifact_rows( ): readonly(any)[]
		artifact_uri( id: any): string
		artifact_title( id: any): string
		project_id( ): string
		ask_questions( next?: boolean ): boolean
		result_visible( ): boolean
		output_mode( next?: string ): string
		after( ): readonly(any)[]
		sub( ): readonly(any)[]
		Process( ): $shm_projects_goal_chat
		Result( ): $mol_view
		Thinking( ): $shm_projects_goal_thinking
		Send( ): $mol_button_major
		Requirements_draft( ): $shm_projects_goal_request
		Timeline( ): $mol_list
		Clarifications( ): $mol_view
		Clarifications_title( ): $mol_view
		Clarifications_list( ): $mol_list
		Clarifications_send( ): $mol_button_major
		Clarification( id: any): $mol_form_field
		Clarification_answer( id: any): $mol_textarea
		Clarification_answer_text( id: any): $mol_text
		Prerelease_status( ): $mol_view
		Prerelease_status_head( ): $mol_view
		Iteration_status( id: any): $mol_view
		Iteration_status_head( id: any): $mol_view
		Iteration_status_title( id: any): $mol_view
		Iteration_status_link( id: any): $mol_link
		Iteration_status_state( id: any): $mol_text
		Iteration_status_elapsed( id: any): $mol_text
		Iteration_rollback( id: any): $mol_button_minor
		Iteration_goal( id: any): $mol_form_field
		Stop( ): $mol_button_minor
		Continue( ): $mol_button_major
		Rollback_all( ): $mol_button_minor
		Iterations( ): $mol_list
		Iteration( id: any): $mol_view
		Iteration_title( id: any): $mol_view
		Iteration_events( id: any): $mol_list
		Iteration_event( id: any): $mol_text
		Iteration_summary( id: any): $mol_text
		Iteration_changes( id: any): $mol_view
		Prerelease( ): $mol_view
		Prerelease_title( ): $mol_view
		Prerelease_state( ): $mol_text
		Prerelease_external_note( ): $mol_text
		Prerelease_events( ): $mol_list
		Prerelease_event( id: any): $mol_text
		Prerelease_summary( ): $mol_text
		Prerelease_changes( ): $mol_view
		Prerelease_change( id: any): $mol_view
		Prerelease_change_title( id: any): $mol_view
		Prerelease_change_description( id: any): $mol_text
		Prerelease_change_screenshots( id: any): $mol_view
		Prerelease_change_demos( id: any): $mol_view
		Prerelease_change_demo( id: any): $shm_projects_goal_demo
		Prerelease_change_screenshot( id: any): $shm_projects_image_viewer
		Prerelease_stop( ): $mol_button_minor
		Prerelease_continue( ): $mol_button_major
		Prerelease_accept_external( ): $mol_button_minor
		Result_change( id: any): $mol_view
		Result_change_title( id: any): $mol_view
		Result_change_description( id: any): $mol_text
		Result_change_screenshots( id: any): $mol_view
		Result_change_demos( id: any): $mol_view
		Result_change_demo( id: any): $shm_projects_goal_demo
		Result_change_screenshot( id: any): $shm_projects_image_viewer
		Refine( ): $mol_button_major
		Refinement_draft( ): $shm_projects_goal_request
		Artifacts( ): $mol_list
		Artifact( id: any): $mol_link
	}
	
}

//# sourceMappingURL=goal.view.tree.d.ts.map